export default __webpack_public_path__ + "/dist/images/8632969.f449ed85ca1b4eef38c853f93b933249.png";